export default __webpack_public_path__ + "static/media/icon-alert.423c8d35.svg";